import { useGetPortfolioAnalytics } from "api/overview/useGetPortfolioAnalytics";
import { getFetchPolicyOptions } from "api/utils";
import { ImpersonationBanner } from "components/ImpersonationBanner/ImpersonationBanner";
import { useGetContractIdData } from "providers/ContractIdProvider";
import { useKeycloak } from "providers/KeycloakProvider";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { PortfolioNavigationHeader } from "./PortfolioNavigationHeader/PortfolioNavigationHeader";

export const PortfolioNavigationHeaderLayout = () => {
  const location = useLocation();
  const isImpersonateRoute = location.pathname.startsWith("/impersonate/");
  const { portfolioId } = useParams();
  const portfolioIdNr = portfolioId ? parseInt(portfolioId, 10) : undefined;

  // ✅ This query will now run ONCE per portfolio load,
  // stay cached, and not be cancelled when navigating between tabs
  const { linkedContact } = useKeycloak();
  const { selectedContactId } = useGetContractIdData();

  const currentContactId = selectedContactId || linkedContact;
  const cacheKey = `cacheKeyForPositionsAndFigures_${currentContactId}`;

  const { fetchPolicy, onCompleted } = getFetchPolicyOptions(cacheKey);

  useGetPortfolioAnalytics(portfolioIdNr, cacheKey, {
    fetchPolicy,
    onCompleted,
  });

  // Preload the year-to-date figures too, so switching the return page to
  // "I år" is instant. Params must match the YTD call in
  // src/views/portfolio/return/return.tsx.
  const ytdStart = new Date(new Date().getFullYear(), 0, 1).toLocaleDateString(
    "sv-SE"
  );
  const ytdKey = `returnYtdFigures_${currentContactId}`;
  const ytdPolicies = getFetchPolicyOptions(`${ytdKey}.${ytdStart}`);
  useGetPortfolioAnalytics(portfolioIdNr, ytdKey, {
    startDate: ytdStart,
    fetchPolicy: ytdPolicies.fetchPolicy,
    onCompleted: ytdPolicies.onCompleted,
  });

  return (
    <div className="flex flex-col h-full">
      {isImpersonateRoute && <ImpersonationBanner />}
      <PortfolioNavigationHeader />
      <Outlet />
    </div>
  );
};
